module.exports = __webpack_public_path__ + "img/003杜建雄.53e1b474.jpg";